import { TableUserModule } from './../../user/table-user/table-user.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DetailGroupComponent } from './detail-group.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { TranslateModule } from '@ngx-translate/core';
import { FormioModule } from '@formio/angular';
import { AngularFrameworkModule } from 'sp-office365-framework';
import { TableUserComponent } from '../../user/table-user/table-user.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
    declarations: [DetailGroupComponent],
    imports: [
        CommonModule,
        AngularFrameworkModule,
        TranslateModule,
        MatTabsModule,
        FormioModule,
        MatSnackBarModule,
        MatToolbarModule,
        MatIconModule,
        TableUserModule,
        DragDropModule,
    ],
    exports: [DetailGroupComponent]
})
export class DetailGroupModule {}
